module.exports = __webpack_public_path__ + "public/img/ban1.881b3dec.png";